<mat-autocomplete autoActiveFirstOption [panelWidth]="280">
  @for (tag of data | archived: false | sortByKey: 'name'; track trackByIndex($index)) {
    <mat-option [value]="tag" (onSelectionChange)="emitSelect($event, tag)">
      <div class="tiime-option">
        <span class="ellipsis">{{ tag.name }}</span>
      </div>
    </mat-option>
  }
  @for (
    tag of data | archived | map: mapToExactMatch : currentInputValue | sortByKey: 'name';
    track trackByIndex($index)
  ) {
    <mat-option [disabled]="true">
      <div class="tiime-option">
        <mat-icon class="archived-icon" svgIcon="icon-archived"></mat-icon>
        <span class="ellipsis">{{ tag.name }}</span>
      </div>
    </mat-option>
  }
  @if (createOption && (currentInputValue | map: mapToShowCreateThreadTag : data)) {
    <mat-option [value]="currentInputValue" (onSelectionChange)="emitCreate($event)">
      <div class="create-option-content">
        <mat-icon fontSet="fontastic" fontIcon="icon-add-fontastic"></mat-icon>
        <span>{{ currentInputValue }}</span>
      </div>
    </mat-option>
  }
</mat-autocomplete>
